<div class="container benficiariesContainer">
  <div class="form-card">
    <!-- ==================== VISTA: LISTA ==================== -->
    <ng-container *ngIf="currentView === 'list'">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <span class="title">
            {{ 'BENEFICIARIES' | translate }}
          </span>
        </div>
        <button class="btn primary-btn" (click)="openCreateView()">
          {{ 'NEW' | translate }}
        </button>
      </div>

      <div class="table-responsive">
        <table class="table table-bordered table-hover">
          <thead class="">
            <th class="table-start">{{ 'NAME' | translate }}</th>
            <th>{{ 'ID_NUMBER' | translate }}</th>
            <th>{{ 'RELATIONSHIP' | translate }}</th>
            <th class="table-end">{{ 'ACTIONS' | translate }}</th>
          </thead>
          <tbody>
            <tr *ngFor="let b of beneficiaries; let i = index">
              <td>{{ b.beneficiaryName }} {{ b.beneficiaryLastName }}</td>
              <td>{{ b.beneficiaryNationalId }}</td>
              <td>{{ b.beneficiaryRelationship }}</td>
              <td class="text-center">
                <button class="btn primary-btn me-2" (click)="openEditView(i)">
                  {{ 'EDIT' | translate }}
                </button>
                <!-- <button class="btn remove-btn" (click)="removeBeneficiary(i)">
                  {{ 'REMOVE' | translate }}
                </button> -->
              </td>
            </tr>
            <tr *ngIf="beneficiaries.length === 0">
              <td colspan="4" class="text-center text-muted py-4">
                {{ 'NO_RESULTS' | translate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!-- ==================== VISTA: CREACIÓN / EDICIÓN ==================== -->
    <ng-container *ngIf="currentView === 'create' || currentView === 'edit'">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <span class="title">
          {{ (currentView === 'create' ? 'CREATE_BENEFICIARIES' : 'EDIT_BENEFICIARY') | translate }}
        </span>
        <button class="btn btn-outline-secondary" (click)="backToList()">
          {{ 'BACK' | translate }}
        </button>
      </div>

      <div class="form-card">
        <form [formGroup]="beneficiaryForm" (ngSubmit)="saveBeneficiary()">
          <div class="content row">
            <div class="loading" *ngIf="loadingBeneficiaries">
              <div class="spinner-border" role="status"></div>
            </div>

            <div class="row" *ngIf="!loadingBeneficiaries">
              <div class="column col-md-4">
                <div class="group-select">
                  <label class="form-label" for="">{{'RELATIONSHIP' | translate}}</label>
                  <select class="custom-select w-100" formControlName="beneficiaryRelationship"
                    (change)="onChangeRelationship($event)">
                    <option value="Titular">{{'HEADLINE' | translate}}</option>
                    <option value="Conyuge">{{'SPOUSE' | translate}}</option>
                    <option value="Unión Libre">{{'DOMESTIC_PARTNERSHIP' | translate}}</option>
                    <option value="Padre">{{'FATHER' | translate}}</option>
                    <option value="Madre">{{'MOTHER' | translate}}</option>
                    <option value="Hermano">{{'BROTHER' | translate}}</option>
                    <option value="Hermana">{{'SISTER' | translate}}</option>
                    <option value="Hijo">{{'SON' | translate}}</option>
                    <option value="Hija">{{'DAUGHTER' | translate}}</option>
                    <option value="Suegra">{{'MOTHER_IN_LAW' | translate}}</option>
                    <option value="Suegro">{{'FATHER_IN_LAW' | translate}}</option>
                    <option value="Perro">{{'DOG' | translate}}</option>
                    <option value="Gato">{{'CAT' | translate}}</option>
                    <option value="Otro">{{'OTHER' | translate}}</option>
                  </select>
                  <div *ngIf="beneficiaryForm.get('beneficiaryRelationship')?.invalid && (beneficiaryForm.get('beneficiaryRelationship')?.dirty || beneficiaryForm.get('beneficiaryRelationship')?.touched)"
                  class="text-danger">
                    <div *ngIf="beneficiaryForm.get('beneficiaryRelationship')?.errors?.['required']">{{'FIELD_REQUIRED' | translate}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="column col-md-4">
                <label class="form-label" for="">{{ 'NAME' | translate }}</label>
                <input class="form-control" id="name" formControlName="beneficiaryName" type="text" />
                <div
                  *ngIf="beneficiaryForm.get('beneficiaryName')?.invalid && (beneficiaryForm.get('beneficiaryName')?.dirty || beneficiaryForm.get('beneficiaryName')?.touched)"
                  class="text-danger">
                  <div *ngIf="beneficiaryForm.get('beneficiaryName')?.errors?.['required']">{{'FIELD_REQUIRED' | translate}}
                  </div>
                </div>
              </div>
              <div class="column col-md-4" *ngIf="this.validRelationships.includes(currentRelationship)">
                <label class="form-label" for=""
                  *ngIf="this.validateResponsibleRelationships.includes(currentRelationship)">{{ 'ANIMAL_BREED' | translate
                  }}</label>
                <input class="form-control" id="beneficiaryBreed" formControlName="beneficiaryBreed" type="text" />
                <div *ngIf="beneficiaryForm.get('beneficiaryBreed')?.invalid && (beneficiaryForm.get('beneficiaryBreed')?.dirty || beneficiaryForm.get('beneficiaryBreed')?.touched)"
                class="text-danger">
                  <div *ngIf="beneficiaryForm.get('beneficiaryBreed')?.errors?.['required']">{{'FIELD_REQUIRED' | translate}}
                  </div>
                </div>
              </div>
              <div class="column col-md-4" *ngIf="!this.validRelationships.includes(currentRelationship)">
                <label class="form-label" for="">{{'LAST_NAME' | translate}}</label>
                <input class="form-control" id="lastName" formControlName="beneficiaryLastName" type="text" />
                <div
                  *ngIf="beneficiaryForm.get('beneficiaryLastName')?.invalid && (beneficiaryForm.get('beneficiaryLastName')?.dirty || beneficiaryForm.get('beneficiaryLastName')?.touched)"
                  class="text-danger">
                  <div *ngIf="beneficiaryForm.get('beneficiaryLastName')?.errors?.['required']">{{'FIELD_REQUIRED' | translate}}
                  </div>
                </div>
              </div>
              <div class="column col-md-4" *ngIf="!this.validRelationships.includes(currentRelationship)">
                <div class="group-select">
                <label class="form-label">{{ 'DOCUMENT_TYPE' | translate }}</label>
                <select class="custom-select w-100" formControlName="beneficiaryDocumentType">
                  <option value="" disabled selected>{{ 'SELECT_DOCUMENT_TYPE' | translate }}</option>
                  <option value="ID">{{'ID_NUMBER' | translate}}</option>
                  <option value="Passport">{{ 'PASSPORT' | translate }}</option>
                    <option value="DIMEX">DIMEX</option>
                </select>
                <div *ngIf="beneficiaryForm.get('beneficiaryDocumentType')?.invalid && (beneficiaryForm.get('beneficiaryDocumentType')?.dirty || beneficiaryForm.get('beneficiaryDocumentType')?.touched)"
                class="text-danger">
                  <div *ngIf="beneficiaryForm.get('beneficiaryDocumentType')?.errors?.['required']">{{'FIELD_REQUIRED' | translate}}
                  </div>
                </div>
              </div>
              </div>
              <div class="column col-md-4" *ngIf="!this.validRelationships.includes(currentRelationship)">
                <label class="form-label" for="">
                  {{ beneficiaryForm.get('beneficiaryDocumentType')?.value === 'Passport' ? ('PASSPORT' | translate) :
                  (beneficiaryForm.get('beneficiaryDocumentType')?.value === 'DIMEX' ? 'DIMEX' : ('ID_NUMBER' | translate)) }}
              </label>
                <input
                  class="form-control"
                  id="beneficiaryNationalId"
                  type="text"
                  formControlName="beneficiaryNationalId"
                  [attr.placeholder]="beneficiaryForm.get('beneficiaryDocumentType')?.value === 'Passport' ? 'Ej: A12345678900' : (beneficiaryForm.get('beneficiaryDocumentType')?.value === 'DIMEX' ? 'Ej: 12345678901' : 'Ej: 123456789')"
                  [disabled]="!beneficiaryForm.get('beneficiaryDocumentType')?.value"
                  (input)="validateBeneficiaryNationalId()"
                  [ngClass]="{ 'border border-red-500': nationalIdInvalid }"
                  />
                  <p *ngIf="nationalIdInvalid" class="text-sm text-red-500 mt-1">
                  {{ 'INVALID_FORMAT' | translate:{type: (beneficiaryForm.get('beneficiaryDocumentType')?.value === 'Passport' ? ('PASSPORT' | translate) : (beneficiaryForm.get('beneficiaryDocumentType')?.value === 'DIMEX' ? 'DIMEX' : ('ID_NUMBER' | translate)))} }}
                  </p>
                <div
                  *ngIf="beneficiaryForm.get('beneficiaryNationalId')?.invalid && (beneficiaryForm.get('beneficiaryNationalId')?.dirty || beneficiaryForm.get('beneficiaryNationalId')?.touched)"
                  class="text-danger">
                  <div *ngIf="beneficiaryForm.get('beneficiaryNationalId')?.errors?.['required']">{{'FIELD_REQUIRED' |
                    translate}}</div>
                </div>
              </div>
              <div class="column col-md-4" *ngIf="this.validRelationships.includes(currentRelationship)">
                <label class="form-label" for=""
                  *ngIf="this.validateResponsibleRelationships.includes(currentRelationship)">{{ 'ANIMAL_COLOR' | translate
                  }}</label>
                <input class="form-control" id="beneficiaryColor" formControlName="beneficiaryColor" type="text" />
              </div>
              <div class="column col-md-4" *ngIf="this.validRelationships.includes(currentRelationship)">
                <label class="form-label" for=""
                  *ngIf="this.validateResponsibleRelationships.includes(currentRelationship)">{{ 'ANIMAL_WEIGHT' | translate
                  }}</label>
                <input class="form-control" id="beneficiaryWeight" placeholder="{{ 'ANIMAL_WEIGHT_PLACEHOLDER' | translate }}" formControlName="beneficiaryWeight" type="number" />
                <div *ngIf="beneficiaryForm.get('beneficiaryWeight')?.invalid && (beneficiaryForm.get('beneficiaryWeight')?.dirty || beneficiaryForm.get('beneficiaryWeight')?.touched)"
                class="text-danger">
                  <div *ngIf="beneficiaryForm.get('beneficiaryWeight')?.errors?.['required']">{{'FIELD_REQUIRED' | translate}}
                  </div>
                </div>
              </div>
              <div class="column col-md-4">
                <label class="form-label" for=""
                  *ngIf="!this.validateResponsibleRelationships.includes(currentRelationship)">{{ 'EMAIL' | translate
                  }}</label>
                <label class="form-label" for=""
                  *ngIf="this.validateResponsibleRelationships.includes(currentRelationship)">{{ 'EMAIL_PERSON_IN_CHARGE' |
                  translate }}</label>
                <input class="form-control" id="beneficiaryEmail" formControlName="beneficiaryEmail" type="text" />
              </div>
              <div class="column col-md-4">
                <label class="form-label" for=""
                  *ngIf="!this.validateResponsibleRelationships.includes(currentRelationship)">{{ 'PHONE' | translate
                  }}</label>
                <label class="form-label" for=""
                  *ngIf="this.validateResponsibleRelationships.includes(currentRelationship)">{{ 'PHONE_PERSON_IN_CHARGE' |
                  translate }}</label>
                <input class="form-control" id="beneficiaryPhone" formControlName="beneficiaryPhone" type="text" />
              </div>
              <div class="column col-md-4">
                <label class="form-label" for="">{{ 'GENDER' | translate }}</label>
                <div class="">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" formControlName="beneficiaryGender" type="radio" id="male"
                      value="male" />
                    <label class="form-check-label" for="male"
                      *ngIf="!this.validRelationships.includes(currentRelationship)">{{ 'MALE' | translate }}</label>
                    <label class="form-check-label" for="male"
                      *ngIf="this.validRelationships.includes(currentRelationship)">{{ 'MALE_ANIMAL' | translate }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" formControlName="beneficiaryGender" type="radio"
                      id="female" value="female" />
                    <label class="form-check-label" for="female"
                      *ngIf="!this.validRelationships.includes(currentRelationship)">{{ 'FEMALE' | translate }}</label>
                    <label class="form-check-label" for="female"
                      *ngIf="this.validRelationships.includes(currentRelationship)">{{ 'FEMALE_ANIMAL' | translate
                      }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" formControlName="beneficiaryGender" type="radio"
                      id="not-indicate" value="" />
                    <label class="form-check-label" for="not-indicate">{{'NOT_INDICATE' | translate}}</label>
                  </div>
                </div>
              </div>
              <div class="column col-md-4 date-range">
                <label class="form-label m-0" for="">{{'BORN_DATE' | translate}}</label>
                <div>
                  <mat-form-field appearance="fill">
                    <mat-label>Choose a date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="beneficiaryBornDate" />
                    <mat-hint>DD/MM/YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div class="column col-md-4" *ngIf="currentView != 'edit'">
                <label class="label-select" for="">{{'PROVINCE' | translate}}</label>
                  <select class="custom-select" formControlName="selectedProvinciaId" (change)="onProvinciaChange($event)">
                    <option value="" disabled selected>{{'SELECT_PROVINCE' | translate}}</option>
                    <option *ngFor="let provincia of provincias" [value]="provincia.id">{{ provincia.name }}</option>
                  </select>
              </div>
              <div class="column col-md-4" *ngIf="currentView != 'edit'">
                <label class="label-select" for="">{{'CANTON' | translate}}</label>
                  <select class="custom-select" formControlName="selectedCantonId" (change)="onCantonChange($event)">
                    <option value="" disabled selected>{{'SELECT_CANTON' | translate}}</option>
                    <option *ngFor="let canton of cantones" [value]="canton.id">{{ canton.name }}</option>
                  </select>
              </div>
              <div class="column col-md-4" *ngIf="currentView != 'edit'">
                <label class="label-select" for="">{{'DISTRICT' | translate}}</label>
                <select class="custom-select" formControlName="selectedDistritoId" (change)="onDistritoChange($event)">
                  <option value="" disabled selected>{{'SELECT_DISTRICT' | translate}}</option>
                  <option *ngFor="let distrito of distritos" [value]="distrito.id">{{ distrito.name }}</option>
                </select>
              </div>
              <div class="column col-md-12" *ngIf="currentView != 'edit'">
                <label class="form-label d-flex align-items-center gap-1" for="address-textarea">
                  {{'ADDRESS' | translate}}
                  <span class="tooltip-icon-wrapper" *ngIf="[12].includes(themingService.shopTheming[0].shopId)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#007bff" viewBox="0 0 16 16">
                      <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zM8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0z"/>
                      <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 .877-.252 1.002-.598l.088-.416c.066-.308.118-.438.288-.47l.451-.082.082-.38-1.293-.287.738-3.468zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                    </svg>
                    <div class="tooltip-bubble">
                      {{'USER_ADDRESS_TOOLTIP' | translate}}
                    </div>
                  </span>
                </label>

                <textarea
                  id="address-textarea"
                  class="form-control"
                  formControlName="beneficiaryAddress"
                  style="resize: none;"
                  rows="5">
                </textarea>
              </div>
              <!-- ... resto de campos de tu formulario original ... -->
            </div>
          </div>

          <div class="btn-box row justify-content-center mt-4" *ngIf="!loadingBeneficiaries">
            <button class="btn remove-btn me-2" type="button" (click)="backToList()">
              {{ 'CANCEL' | translate }}
            </button>
            <button class="btn primary-btn" type="submit">
              {{ (currentView === 'create' ? 'CREATE_BENEFICIARY' : 'UPDATE_BENEFICIARY') | translate }}
            </button>
          </div>
        </form>
      </div>
    </ng-container>

  </div>
</div>

<div class="modal beneficiary-modal-dialog" id="successCreateBeneficiariesModal" tabindex="-1">
  <div class="modal-dialog product-modal-dialog" role="document">
    <div class="modal-content beneficiary-modal-body">
      <div class="modal-body product-modal-body">
        <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
        <p class="text-center">{{'BENEFICIARY_SUCCESSFULLY_CREATED' | translate}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger confirm-btn" (click)="closeBeneficiariesModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal beneficiary-modal-dialog" id="successUpdateBeneficiariesModal" tabindex="-1">
  <div class="modal-dialog product-modal-dialog" role="document">
    <div class="modal-content beneficiary-modal-body">
      <div class="modal-body product-modal-body">
        <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
        <p class="text-center">{{'BENEFICIARY_SUCCESSFULLY_UPDATED' | translate}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger confirm-btn" (click)="closeBeneficiariesModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal beneficiary-modal-dialog" id="errorBeneficiariesModal" tabindex="-1">
  <div class="modal-dialog product-modal-dialog" role="document">
    <div class="modal-content beneficiary-modal-body">
      <div class="modal-body product-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{'ERROR_SAVING_CHANGES' | translate}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger cancel-btn" (click)="closeBeneficiariesModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal beneficiary-modal-dialog" id="errorTwoBeneficiariesModal" tabindex="-1">
  <div class="modal-dialog product-modal-dialog" role="document">
    <div class="modal-content beneficiary-modal-body">
      <div class="modal-body product-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{'BENEFICIARIES_DUPLICATE' | translate}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger cancel-btn" (click)="closeBeneficiariesModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>